import styled from 'styled-components';

export const Container = styled.div`
  width: 80%;
  margin: 5rem auto 0;
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2.4fr 7fr;
  column-gap: 10rem;
  align-items: flex-start;
  margin: 1.6rem auto 5rem;

  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const ContentContainer = styled.div`
  h1 {
    font-weight: 700;
    font-size: 3.2rem;
    line-height: 4.8rem;
    color: ${({ theme }) => theme.color.primary};

    width: fit-content;
    padding-bottom: 3rem;
    border-bottom: 1px solid rgba(170, 170, 170, 0.64);
    margin-bottom: 4rem;
  }

  @media (max-width: 640px) {
    h1 {
      font-weight: 500;
      font-size: 2.1rem;
      line-height: 3.2rem;
    }
  }
`;

export const Content = styled.div`
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2.4rem;
  text-align: justify;

  p {
    + p {
      margin-top: 1.5rem;
    }
  }

  ul {
    margin-top: 1.5rem;
    padding-left: 2.4rem;

    list-style: disc;

    li {
      + li {
        margin-top: 0.4rem;
      }
    }

    + p {
      margin-top: 1.5rem;
    }
  }
`;

export const SideNav = styled.aside`
  & > div:first-child {
    padding-bottom: 2.4rem;
    border-bottom: 1px solid rgba(170, 170, 170, 0.64);
  }

  @media (max-width: 640px) {
    > div:first-child {
      border: none;
    }
  }
`;

export const Contact = styled.div`
  margin-top: 3.2rem;

  p {
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 2.1rem;
  }

  span {
    display: block;
    margin-top: 0.4;

    font-weight: 400;
    font-size: 1.1rem;
    line-height: 1.6rem;
  }
`;

export const LinksContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  margin-top: 3.2rem;

  a {
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 1.95rem;
    color: #212121;
    text-decoration: none;

    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.color.primary};
      text-decoration: none;
    }

    &.selected {
      color: ${({ theme }) => theme.color.primary};
    }
  }
`;
